export default {
  data: function() {
    return {
        get isOneStop() {
          return !!(<any>window).ONE_STOP
        },
        get isDNR() {
          return !!(<any>window).DNR
        },
        get isNotOneStop() {
          return !!!(<any>window).ONE_STOP
        },
        get isFormability() {
          return !!(<any>window).FORMABILITY
        },
    }
  },
};